import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5343246"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "line1",
  viewBox: "0 0 20 2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "1",
  y1: "1",
  x2: "19",
  y2: "1"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  ref: "line2",
  viewBox: "0 0 20 2"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "1",
  y1: "1",
  x2: "19",
  y2: "1"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  ref: "line3",
  viewBox: "0 0 20 2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "1",
  y1: "1",
  x2: "19",
  y2: "1"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "MenuMobile__Trigger",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3, 512)),
    (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6, 512)),
    (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9, 512))
  ]))
}